import { APIDecoratorWithBaseURI } from '../../Service/api'
import { downloadBase64File } from '../../utils/download-file'

// Versão do termo de uso aceito (registrada no log de auditoria).
export const MAILING_TERMO_ID = '1.0'

/**
 * Hook de download da base de mailing. Espelha o padrão do useWithdraw:
 * o fetcher é passado ao ConfirmationModal (2FA) como submitResponse e, ao
 * receber a resposta, dispara o download do arquivo base64 no navegador.
 */
export const useMailingExport = (
  eventId: string | undefined,
  termsAccepted: boolean,
  code: string
) => {
  const url = 'producer/analytics/exportMailing'

  const mailingExportFetcher = async () => {
    const response = await APIDecoratorWithBaseURI().post(url, {
      params: {
        eventId,
        code2FA: code.toString(),
        termsAccepted,
        termoId: MAILING_TERMO_ID,
      },
    })

    const body = response?.data
    if (body?.success && body?.data?.fileBase64) {
      downloadBase64File(
        body.data.fileBase64,
        body.data.fileName,
        body.data.mime
      )
    }

    return response
  }

  return { mailingExportFetcher }
}
